import React from "react";
import HeaderSA from "./HeaderSA";
import SidebarSA from './SidebarSA';
import './layoutSA.css';

const LayoutSA = ({ children, logout, isActive, toggleSidebar, closeSidebar }) => {
    return (
        <>
            <HeaderSA toggleSidebar={toggleSidebar} logout={logout} isActive={isActive} closeSidebar={closeSidebar} />
            <SidebarSA isActive={isActive} logout={logout} closeSidebar={closeSidebar} />
            <div className='main-container-superAdmin'>
                {children}
            </div>
        </>
    );
};

export default LayoutSA;
